<script setup lang="ts">
import { ASSETS, LX_BIDS, WHY_DIGITAL_HUMAN } from './constants'
</script>

<template>
  <section
    id="whyDigitalHumanSection"
    class="why-digital-human-section"
    :data-mv-bid="LX_BIDS.whyMliveMv"
    data-mv-key="why-mlive"
    :data-mv-module-identifier="1"
  >
    <!-- 桌面端：保持原拼图网格 -->
    <div class="why-digital-desktop">
      <div class="section-heading">
        <div class="section-title">
          <span>为什么选择</span>
          <span class="accent">数字人直播？</span>
        </div>
        <div class="section-sub">降低开播门槛，突破人力与时间限制，让直播经营更稳定、更高效</div>
      </div>

      <div class="why-grid">
        <article class="why-card card-1">
          <div class="why-card-body">
            <div class="why-card-title">{{ WHY_DIGITAL_HUMAN[0].title }}</div>
            <div class="why-card-desc">{{ WHY_DIGITAL_HUMAN[0].description }}</div>
          </div>
          <img
            class="why-media"
            :src="ASSETS.whyMliveMediaTop"
            alt=""
            aria-hidden="true"
          >
        </article>

        <article class="why-card card-2">
          <div class="why-card-title">{{ WHY_DIGITAL_HUMAN[1].title }}</div>
          <div class="why-card-desc">{{ WHY_DIGITAL_HUMAN[1].description }}</div>
        </article>

        <article class="why-card card-3">
          <div class="why-card-title">{{ WHY_DIGITAL_HUMAN[2].title }}</div>
          <div class="why-card-desc">{{ WHY_DIGITAL_HUMAN[2].description }}</div>
          <img
            class="why-card-icon"
            src="https://p1.meituan.net/mliveimage/2ac0033c19fe11c4832b216197c8b2c620800.png"
            alt=""
            aria-hidden="true"
          >
        </article>

        <article class="why-card card-4">
          <div class="why-card-title">{{ WHY_DIGITAL_HUMAN[3].title }}</div>
          <div class="why-card-desc">{{ WHY_DIGITAL_HUMAN[3].description }}</div>
        </article>

        <article class="why-card card-5">
          <div class="why-card-title">{{ WHY_DIGITAL_HUMAN[4].title }}</div>
          <div class="why-card-desc">{{ WHY_DIGITAL_HUMAN[4].description }}</div>
        </article>
      </div>
    </div>

    <!-- 移动端：按设计稿 1452503 双列摆放（图片占位，后续可替换） -->
    <div class="why-digital-mobile">
      <div class="section-heading">
        <div class="section-title">
          <span>为什么选择</span>
          <span class="accent">数字人直播？</span>
        </div>
        <div class="section-sub">降低开播门槛，突破人力与时间限制，让直播经营更稳定、更高效</div>
      </div>

      <div class="mobile-cols">
        <div class="mobile-col mobile-col-left">
          <article class="why-card">
            <div class="why-card-title">{{ WHY_DIGITAL_HUMAN[0].title }}</div>
            <div class="why-card-desc">{{ WHY_DIGITAL_HUMAN[0].description }}</div>
          </article>
          <img
            class="why-media"
            :src="ASSETS.whyMliveMediaTop"
            alt=""
            aria-hidden="true"
          >
          <article class="why-card">
            <div class="why-card-title">{{ WHY_DIGITAL_HUMAN[2].title }}</div>
            <div class="why-card-desc">{{ WHY_DIGITAL_HUMAN[2].description }}</div>
          </article>
          <article class="why-card">
            <div class="why-card-title">{{ WHY_DIGITAL_HUMAN[4].title }}</div>
            <div class="why-card-desc">{{ WHY_DIGITAL_HUMAN[4].description }}</div>
          </article>
        </div>

        <div class="mobile-col mobile-col-right">
          <article class="why-card">
            <div class="why-card-title">{{ WHY_DIGITAL_HUMAN[1].title }}</div>
            <div class="why-card-desc">{{ WHY_DIGITAL_HUMAN[1].description }}</div>
          </article>
          <article class="why-card">
            <div class="why-card-title">{{ WHY_DIGITAL_HUMAN[3].title }}</div>
            <div class="why-card-desc">{{ WHY_DIGITAL_HUMAN[3].description }}</div>
          </article>
          <img
            class="why-media"
            :src="ASSETS.whyMliveMediaBottom"
            alt=""
            aria-hidden="true"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.why-digital-human-section {
  width: 1200px;
  max-width: calc(100% - 48px);
  margin: 180px auto 0;
}

.section-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 21px;
  margin-bottom: 48px;
  text-align: center;
}

.section-title {
  display: flex;
  gap: 24px;
  color: #171717;
  font-size: 48px;
  font-weight: 700;
  line-height: normal;
}

.accent {
  color: #8932ff;
}

.section-sub {
  color: #666;
  font-size: 18px;
  font-weight: 300; /* L */
  line-height: normal;
}

.why-grid {
  display: grid;
  grid-template-columns: 386px 321px 460px;
  grid-template-rows: 160px 134px 134px;
  gap: 32px 31px;
}

.why-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 24px;
  border-radius: 24px;
  background: #f7f7f7;
  box-sizing: border-box;
}

.why-card-title {
  color: #171717;
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
}

.why-card-desc {
  color: #666;
  font-size: 16px;
  line-height: 1.6;
}

.card-1 {
  grid-column: 1 / 3;
  grid-row: 1;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
  padding: 0;
  overflow: hidden;
  background: #f6f6f6;
}

.why-card-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  padding: 32px 24px;
}

.why-media {
  flex: none;
  width: 224px;
  border-radius: 0 24px 24px 0;
  background: #f0f0f0;
}

.card-2 {
  grid-column: 3;
  grid-row: 1;
}

.card-3 {
  grid-column: 1;
  grid-row: 2 / 4;
  min-height: 300px;
}

.why-card-icon {
  width: 52px;
  height: 57px;
  margin-top: auto;
  opacity: 0.7;
  object-fit: contain;
}

.card-4 {
  grid-column: 2 / 4;
  grid-row: 2;
}

.card-5 {
  grid-column: 2 / 4;
  grid-row: 3;
}

.why-digital-mobile {
  display: none;
}

@media (max-width: 960px) {
  .why-digital-human-section {
    width: auto;
    max-width: none;
    margin: 64px 20px 0;
  }

  .why-digital-desktop {
    display: none;
  }

  .why-digital-mobile {
    display: block;
  }

  .why-digital-mobile .section-heading {
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 20px;
    text-align: left;
  }

  .why-digital-mobile .section-title {
    flex-wrap: wrap;
    gap: 8px;
    font-size: 28px;
  }

  .why-digital-mobile .section-sub {
    font-size: 16px;
    line-height: 1.47;
    font-weight: 300;
  }

  .mobile-cols {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    align-items: start;
  }

  .mobile-col {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
  }

  .why-digital-mobile .why-card {
    gap: 10px;
    padding: 16px 14px;
    border-radius: 16px;
  }

  .why-digital-mobile .why-card-title {
    font-size: 15px;
  }

  .why-digital-mobile .why-card-desc {
    font-size: 12px;
    font-weight: 300;
  }

  .why-digital-mobile .why-media {
    width: 100%;
    height: auto;
    aspect-ratio: 334 / 216;
    border-radius: 16px;
    object-fit: cover;
  }
}
</style>
